import * as Ramda from 'ramda';

import type { JSONSchema4 } from 'json-schema';
import type { ProductType } from '../../../../types';
import { ProductTypes } from '../../../../types';
import { FieldType } from '../../../parsing/parser';

export const determineIfRequired = (
  fieldType: FieldType,
  schema: JSONSchema4 | undefined,
  requiredOverride?: boolean
) => {
  if (fieldType === FieldType.FieldList) {
    return false;
  }

  // Option B: only surface required where it will actually be enforced. A field with no
  // schema (or a JobList, which short-circuits Yup building in getYupSchemaForField) is
  // never validated, so the element-level override must not render an unenforced asterisk.
  if (!schema) {
    return false;
  }

  if (requiredOverride === true && fieldType !== FieldType.JobList) {
    return true;
  }

  return Array.isArray(schema.required) && Boolean(schema.required?.length);
};

export const isLegacyStyleFormProduct = (productType: ProductType) => {
  return [ProductTypes.p100, ProductTypes.p250].some(Ramda.equals(productType));
};
